module.exports = __webpack_public_path__ + "img/done.f9edb7a1.svg";